import * as React from 'react';
import '../DatePicker.scss';

const DaysBlock = props => {
  return (
    <div className="datePickerDays">
      <div className="weekName">
        <span>ش</span>
        <span>ی</span>
        <span>د</span>
        <span>س</span>
        <span>چ</span>
        <span>پ</span>
        <span>ج</span>
      </div>
      <div className="daysBlock">
        {props.days.map((day, i) => {
          if (!day) {
            return <div key={i} className="days nodays"></div>;
          }

          return (
            <div key={i} className="days" onClick={() => props.onDaySelected(day)}>
              {day.dayJalali}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default DaysBlock;
